export default {
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    allAlbums() {
      const allAlbums = this.$store.getters.ALL_ALBUMS;
      return allAlbums ? allAlbums : null;
    },
    items() {
      return this.allAlbums && this.allAlbums.data ? this.allAlbums.data : null;
    },
    rows() {
      if (this.allAlbums && this.allAlbums.total) {
        return +this.allAlbums.total;
      }

      return 0;
    },
    perPage() {
      if (this.allAlbums && this.allAlbums.data) {
        return +this.allAlbums.limit;
      }

      return 0;

    },
    groupedCategories() {
      return this.$store.getters.GROUPED_CATEGORIES;
    },
    categoryName() {
      if (this.$route.params && this.$route.params.categoryId &&
          this.$route.params.year && this.groupedCategories &&
          this.groupedCategories.length > 0) {
        const categoryName = this._.find(this.groupedCategories,
            {id: this.$route.params.categoryId});

        if (categoryName && categoryName.title) {
          return `${categoryName.title} ${this.$route.params.year}`;
        }
      }

      return '';
    },
  },
  watch: {
    '$route'() {
      this.$store.dispatch('INIT_ALL_ALBUMS',
          {params: this.$route.params, vm: this});
    },
    currentPage(page) {
      if (this.$route.params.page !== page) {
        let url = 'album';
        const params = this.$route.params;

        if (params.categoryId && params.year) {
          url += `/category/${params.categoryId}/${params.year}`;
        }

        if (page && +page > 0) {
          url += `/${page}`;
        }

        this.$router.push(this.i18nLink(url));
      }
    },
  },
  created() {
    if (this.$route.params.page) {
      this.currentPage = this.$route.params.page;
    }

    this.$store.dispatch('INIT_ALL_ALBUMS',
        {params: this.$route.params, vm: this});
  },
};
